import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/niemit.png'


const _withScopeId = n => (_pushScopeId("data-v-27d83a8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_2 = {
  class: "float_login",
  style: {"border-radius":"10px","padding":"10px","background-color":"#333333","opacity":"0.85"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold","color":"white"} }, "Username", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold","color":"white"} }, "Password", -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "float-logo" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", { class: "content" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "height_logo_niemit"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          style: _normalizeStyle(_ctx.backgroundStyle),
          class: "center"
        }, null, 4),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          class: "custom",
                          fill: "outline",
                          autofocus: true,
                          modelValue: _ctx.model.username,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.username) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          class: "custom",
                          fill: "outline",
                          type: "password",
                          modelValue: _ctx.model.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Non ricordo")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, { size: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "success",
                          onClick: _ctx.Login_click
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Log in")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { style: {"text-align":"center"} }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _ctx.appStore.$LOGO_IMAGE,
                          class: "logo_nallebio"
                        }, null, 8, _hoisted_5)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_ion_alert, {
          "is-open": _ctx.isOpenRef,
          header: "Attenzione",
          "sub-header": "Errore",
          message: _ctx.AlertMessage,
          buttons: ['OK'],
          onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ShowAlert(false)))
        }, null, 8, ["is-open", "message"])
      ]),
      _: 1
    }),
    _hoisted_6
  ], 64))
}